import FourOhFourPage from './view';

export default FourOhFourPage;
